import { FieldPath, FieldValues } from "react-hook-form";

import SinglePickerFormField from "src/components/Pickers/SinglePickerFormField.tsx";
import { PickerFormFieldPropsType } from "src/components/Pickers/typings.ts";
import { useGetRulesQuery } from "src/graphql/anti-fraud/queries/rules/GetRulesQuery.ts";
import { useT } from "src/internationalization";
import { Rule } from "src/types/rule";

function RuleSinglePickerFormField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  props: PickerFormFieldPropsType<Rule, TFieldValues, TName> & {
    caseTypeCode: string;
    placeholder?: string;
  }
) {
  const { data, loading, error } = useGetRulesQuery({
    variables: { caseTypeCode: props.caseTypeCode },
  });
  const t = useT();

  return (
    <SinglePickerFormField<Rule, TFieldValues, TName>
      items={data}
      name={props.name}
      loading={loading}
      rules={props.rules ?? { required: true }}
      error={error}
      placeholder={props.placeholder}
      invalidText={props.invalidText ?? t("general.form.field.required")}
      titleText={props.titleText}
      helperText={props.helperText}
      itemToString={(item) => item?.name ?? ""}
    />
  );
}

export default RuleSinglePickerFormField;
